module.exports = __webpack_public_path__ + "media/images/new_landing/favicon/mstile-144x144-4def58b574b0a4b72dd50432162b5413.png";